<template>
  <h3 class="font-semibold text-gray-700 text-xl">{{ title }}</h3>
  <div id="chart4">
    <apexchart
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "AELiquidationsQueryByProviderProvidersWeekly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    providers: { required: true },
    title: { default: '' },
    y_label: { default: '' },
    formatter: { required: true }
  },
  data() {},
  computed: {
    series() {
      return [
        {
          name: "Kilos Exportados",
          data: this.data_ok,
          type: 'bar'
        },
        ...this.provider_series,
      ];
    },
    options() {
      return {
        chart: {
          type: "line",
          height: 350,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        stroke: {
          width: [0, ]
        },
        markers: {
          size: 0,
          style: "hollow"
        },
        xaxis: {
          tickPlacement: "between",
          group: {
            groups: this.groups,
            style: {
              fontSize: "14px",
              fontWeight: 500
            }
          }
        },
          yaxis: [
            {
              title: { text: "Kilogramos" },
              show: true,
              labels: {
                formatter: function (val) {
                  return this.numberWithPrecision(val, 2);
                }.bind(this)
              }
            },
            ...Array(this.providers.length).fill({
              title: { text: this.y_label },
              show: false,
              opposite: true,
              labels: {
                formatter: function (val) {
                  if (!Number(val)) return;
                  return `$${this.numberWithPrecision(val, 2)}`;
                }.bind(this)
              }
            }),
          ],
          tooltip: {
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
          },
        colors: [
          "#65A30D",
          ...Array(Math.ceil(this.providers.length / this.line_colors.length)).fill(this.line_colors).flat()
        ]
      };
    },
    line_colors() {
      return ["#3b82f6", "#ef4444", "#f97316", "#84cc16", "#10b981", "#a855f7", "#f43f5e", "#eab308"];
    },
    data_ok() {
      return Object.values(this.data)
        .flat()
        .map(data => {
          return {
            x: `${data.week}`,
            y: data.ok
          };
        });
    },
    provider_series() {
      return this.providers.map(provider => {
        return {
          name: provider.name,
          data: this.providerData(provider),
          type: 'line'
        }
      });
    },
    groups() {
      return Object.keys(this.data).map(key => {
        return {
          title: key,
          cols: this.data[key].length
        };
      });
    }
  },
  methods: {
    providerData: function (provider) {
      let data = []
      for (const [month, month_data] of Object.entries(this.data)) {
        month_data.forEach(week_data => {
          data.push({
            x: `${week_data.week}`,
            y: Number(week_data.total_amount_by_provider[provider.id]) || null,
            week_data: week_data,
            month: month
          })
        })
      }

      return data;
    }
  }
};
</script>
